import { Button, Checkbox, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGlaMapBrokerageCode extends Layout {
    buttonReview: Button;
    checkboxSaveAsP44Blank: Checkbox;
    checkboxSaveAsSMC3Blank: Checkbox;
    labelG: Label;
    labelI: Label;
    labelP: Label;
    labelS: Label;
    panelGLA: Panel;
    panelInternal: Panel;
    panelMapping: Panel;
    panelP44: Panel;
    panelSMC3: Panel;
    panelSpacer: Panel;
    panelWorksheet: Panel;
    sourceMapBrokerageCode: DataSource;
    tableMapBrokerageCode: Table;
    textboxDeductCode: Textbox;
    textboxDescription: Textbox;
    textboxFromP44: Textbox;
    textboxFromSmc3: Textbox;
    textboxGlaCode: Textbox;
    textboxOtherChargeCode: Textbox;
    textboxToP44: Textbox;
    textboxToSmc3: Textbox;
}
